export { registerComponent as registerBoxComponent } from '../../components/builtin/Box/register'
export { default as Box } from '../../components/builtin/Box/Box'
